import type { ReactNode } from 'react';
import { createContext } from 'react';
import { useCheckboxGroup } from 'react-aria';
import {
  type CheckboxGroupProps,
  type CheckboxGroupState,
  useCheckboxGroupState,
} from 'react-stately';

interface CheckboxGroup extends CheckboxGroupProps {
  readonly children: ReactNode;
}

export const CheckboxGroupContext = createContext<CheckboxGroupState | null>(
  null,
);

function CheckboxGroup(props: CheckboxGroup) {
  const { children, label } = props;
  const state = useCheckboxGroupState(props);
  const { groupProps, labelProps } = useCheckboxGroup(props, state);

  return (
    <div {...groupProps}>
      <span {...labelProps} className="sr-only">
        {label}
      </span>
      <CheckboxGroupContext.Provider value={state}>
        {children}
      </CheckboxGroupContext.Provider>
    </div>
  );
}

export default CheckboxGroup;
